export const getSudsteiermarkData = () => ({
  name: "Südsteiermark",
  region: "Steiermark",
  country: "Autriche",
  description: "Südsteiermark est la plus importante sous-région viticole de Steiermark, réputée pour ses vins blancs frais et aromatiques. Cette région bénéficie d'un climat continental avec des influences alpines, créant des conditions idéales pour la production de vins blancs de qualité.",
  type: "subregion",
  area: "1,500 ha",
  production: "0.09 million hectolitres",
  climate: "Climat continental avec influences alpines, étés frais et hivers froids",
  soil: "Sols calcaires, argileux, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental avec influences alpines, étés frais et hivers froids",
    soil: "Sols calcaires, argileux, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs frais et aromatiques, avec une acidité vive et des notes minérales",
    red: "Vins rouges légers et fruités, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Südsteiermark remonte à l'époque romaine. La région a développé une réputation pour ses vins blancs de qualité, notamment le Sauvignon Blanc et le Chardonnay. Aujourd'hui, Südsteiermark est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Cuisine autrichienne traditionnelle, poissons, fromages frais, plats locaux",
  grapeVarieties: [
    {
      name: "Sauvignon Blanc",
      percentage: "45%",
      description: "Cépage blanc principal, produisant des vins frais et aromatiques",
      characteristics: "Frais, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Chardonnay",
      percentage: "30%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Welschriesling",
      percentage: "15%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Muscat",
      percentage: "5%",
      description: "Cépage blanc produisant des vins aromatiques et floraux",
      characteristics: "Aromatique, floral, notes musquées",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant des cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Südsteiermark", x: 15.5, y: 47.0, color: "#4B164C", size: 3 }
  ]
}); 